import React from 'react'
import { interpolateRichHtml } from '../utils/introRichText'

const formatWholeCurrency = (amount) =>
  '$' + Math.round(Number(amount) || 0).toLocaleString('en-US')

// Page-2 "Proposal at a Glance": property snapshot + recommended-plan card,
// guarantee strip, stat band, and an included vs billed-separately split.
const ExecutiveSummary = ({ data, crmSnapshot, variables }) => {
  const property = data?.property || {}
  const propertyName = property.name || crmSnapshot?.clientName || ''
  const propertyAddress = property.address || crmSnapshot?.clientAddress || ''
  const propertyRows = property.rows || []
  const rec = data?.recommended || null
  const guarantees = data?.guarantees || []
  const stats = data?.stats || []
  const noteHtml = data?.noteEnabled ? interpolateRichHtml(data?.noteHtml || '', variables) : ''

  return (
    <div className="proposal-section">
      <div className="proposal-section__headline">{data?.headline || 'Proposal at a Glance'}</div>
      <div className="proposal-section__accent-line" />

      <div className="exec-summary__cards">
        <div className="exec-summary__card">
          <div className="exec-summary__card-eyebrow">The Property</div>
          <div className="exec-summary__card-title">{propertyName}</div>
          {propertyAddress && <div className="exec-summary__card-sub">{propertyAddress}</div>}
          {propertyRows.length > 0 && (
            <div className="exec-summary__rows">
              {propertyRows.map((row, i) => (
                <div className="exec-summary__row" key={i}>
                  <span>{row.label}</span>
                  <span className="exec-summary__row-value">{row.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {rec && (
          <div className="exec-summary__card exec-summary__card--rec">
            <div className="exec-summary__card-eyebrow exec-summary__card-eyebrow--gold">
              {rec.single ? 'Your Plan' : <>Recommended &middot; {rec.name}</>}
            </div>
            <div className="exec-summary__rec-price">
              {formatWholeCurrency(rec.monthly)}<span className="exec-summary__rec-per"> / mo</span>
            </div>
            <div className="exec-summary__rec-sub">
              {formatWholeCurrency(rec.annual)} / yr &middot; {formatWholeCurrency(rec.startupOneTime)} one-time start-up
            </div>
            {(rec.items || []).length > 0 && (
              <div className="exec-summary__rec-items">
                {rec.items.map((item, i) => (
                  <div className="exec-summary__rec-item" key={i}>
                    <span className="exec-summary__rec-check">&#10003;</span> {item}
                  </div>
                ))}
              </div>
            )}
            <div className="exec-summary__rec-note">
              {rec.single ? 'Full pricing and scope details inside.' : 'Full comparison of all plans inside.'}
            </div>
          </div>
        )}
      </div>

      {guarantees.length > 0 && (
        <div className="exec-summary__guarantees">
          {guarantees.map((g, i) => (
            <div className="exec-summary__guarantee" key={i}>
              <div className="exec-summary__guarantee-value">{g.value}</div>
              <div className="exec-summary__guarantee-label">{g.label}</div>
            </div>
          ))}
        </div>
      )}

      {stats.length > 0 && (
        <div className="exec-summary__stats">
          {stats.map((s, i) => (
            <div className="exec-summary__stat" key={i}>
              <div className="exec-summary__stat-value">{s.value}</div>
              <div className="exec-summary__stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      )}

      {(data?.includedItems || data?.billedSeparatelyItems) && (
        <div className="exec-summary__split">
          {data?.includedItems && (
            <div className="exec-summary__split-col">
              <div className="exec-summary__split-title">Included in your monthly fee</div>
              <div className="exec-summary__split-body">{data.includedItems}</div>
            </div>
          )}
          {data?.billedSeparatelyItems && (
            <div className="exec-summary__split-col">
              <div className="exec-summary__split-title exec-summary__split-title--gold">Billed separately</div>
              <div className="exec-summary__split-body">{data.billedSeparatelyItems}</div>
            </div>
          )}
        </div>
      )}

      {noteHtml && (
        <div
          className="exec-summary__note proposal-rich-text"
          dangerouslySetInnerHTML={{ __html: noteHtml }}
        />
      )}
    </div>
  )
}

export default ExecutiveSummary
